import React, { PureComponent } from "react";
import { Redirect } from "react-router";
import * as myConstClass from "../../constant.js";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.scss";
import moment from "moment";
import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Label,
  FormGroup,
  CustomInput,
  Form,
  Input,
} from "reactstrap";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
  AvFeedback,
} from "availity-reactstrap-validation";
import { T, Config, TF } from "react-translator-component";
const image = `https://workzonepro.workzoneplus.com/backend/img/Work-Zone-Plus-logo.png`;
const image2 = `https://workzonepro.workzoneplus.com/backend/img/clock.png`;

// const {logout} = props.location.state;
class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: "1",
      showPassword: false,
      toDashboard: false,
      timeOut: 5000,
      showCloseButton: true,
      progressBar: true,
      position: "top-right",
      submitted: false,
    };
    // this.login = this.login.bind(this);
    this.onDocChangeHandler = this.onDocChangeHandler.bind(this);
    this.handleCheckChangeHourLeave =
      this.handleCheckChangeHourLeave.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleCheckChangeHourLeave() {
    this.setState({
      hourchecked: !this.state.hourchecked,
    });
  }

  handleSubmit = (event, errors, values) => {
    //$('html, body').animate({ scrollTop: 0 }, 'fast');
   

    // if (i !== 0) {
    //   return;
    // }
  };

  handleValidSubmit = () => {
  
    this.setState({ submitted: false }, () => {
   
      fetch(
        myConstClass.SITE_URL +
          this.state.url +
          `index.php/shifts/add_ot_request/${this.state.tenant_id}/0/0`,
        {
          method: "POST",
          body:JSON.stringify($("#pformm").serializeArray()),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.setState({ submitted: false });
          if (response === 5) {
            toastr.error(
              TF("{0}", T("Error")),
              TF(
                "{0} {1} {2} {3} {4} {5} {6}",
                T("Attendance"),
                T("Not"),
                T("Present"),
                T("this"),
                T("Day"),
                T("or"),
                T("Closed")
              ),
              this.options
            );
          } else {
            toastr.success(
              TF("{0}", T("Success")),
              TF("{0}", T(myConstClass.UPDATEMSG)),
              this.options
            );
            localStorage.setItem("ot", "0");
            window.location.href = "/";
          }
        })
        .catch();
    });
  };
  componentDidMount() {
    // localStorage.setItem('forget', '0');
    // window.location.href = '/';
    $(".main").css("background-image", "none");
    $(".main").css("background-size", "none");
    //alert('hii');
    // if(this.state.interval_dynamic=='2')
    // {
    //this.interval = setInterval(() => this.tick(), 30000);
    // }
  }
  onFormCancel = () => {
    localStorage.setItem("leave", "0");
    window.location.href = "/";
  };
  onFormSubmit = () => {
    this.setState({ submitted: true }, () => {
      setTimeout(() => this.setState({ submitted: false }), 5000);

      fetch(myConstClass.LOGIN_URL + `user/getEmployeeID`, {
        method: "POST",
        body: JSON.stringify($("#pform").serializeArray()),
      })
        .then((response) => response.json())
        .then((response) => {
          var code = $("#code").val();
          if (response == 2) {
            toastr.error("Error", "Please enter Employee ID..!", this.options);
          } else if (response == 3) {
            toastr.error("Error", "password Does not exists..!", this.options);
          } else if (response) {
            this.setState({ form: 0 });
            this.setState({ tenant_id: response.tenant_id });
            this.setState({ employee_id: response.id });
            this.setState({ organization_id: response.organization_id });
            this.setState({ url: response.url });

            fetch(
              myConstClass.SITE_URL +
                response.url +
                "index.php/attendance/get_all_employees/" +
                response.tenant_id
            )
              .then((response) => response.json())
              .then((response) => {
                this.setState({ emp: response });
              })
              .catch((err) => console.log(err));

            // localStorage.setItem('qrscan', '0');
            // this.props.history.push({
            //   pathname : '/'+myConstClass.TENANT_PAGE_PATH+'/organizationqrcode/qrcode',

            //   state :{
            //   _id : response.qrimage,
            //   }
            //   }
            // );
            //localStorage.setItem('signup', '1');

            // toastr.success(
            //   'Success',
            //   "Password Sent Successfully on your email..!",
            //   this.options
            // )
            // window.location.href = '/';
          } else {
            toastr.error("Error", "password Does not exists..!", this.options);
          }
        })
        .catch();
    });
  };

  handleFromDateChange = (date) => {
    this.setState({ ot_date: date });
    const $box = $("#spanfmdatebox");
    const $label = $("#spanfmdatelabel");
    const $error = $("#spanfmdate");

    if (date) {
      $box.removeClass("is-invalid1").css("border-color", "hsl(0,0%,80%)");
      $label.css("color", "#3e4676");
      $error.hide();
    } else {
      $box.addClass("is-invalid1").css("border-color", "#dc3545");
      $label.css("color", "#dc3545");
      $error.show();
    }
  };
  onDocChangeHandler(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        // imagePreviewUrl: reader.result
      });
    };
    reader.readAsDataURL(file);
  }

  render() {
    const { formData, units, submitted, current_bal, org } = this.state;
    const { emp, leaves } = this.state;
    if (this.state.toDashboard === true) {
      window.location.href = "/dashboard";
      return <Redirect to="/dashboard" />;
    }

    let balance_div;
    let bal;
    balance_div = current_bal
      ? current_bal.map((cell, i) => {
          return (
            <Row>
              <Col lg={6}>
                <label>{cell.leave_title}</label>
              </Col>

              <Col lg={3}>
                <label>{cell.current_balance}</label>
              </Col>
              <Col lg={3}>
                <label>{cell.is_negative}</label>
              </Col>
            </Row>
          );
        })
      : "";
    const start =
      this.state.checked == "1" || this.state.hourchecked == "1" ? null : (
        <AvGroup>
          <Label for="example">
            {TF("{0} {1} {2}", T("Select"), T("Start"), T("Time"))}
          </Label>
          <AvField
            type="select"
            id="from_date_time"
            value={
              formData ? formData.from_date_time : this.state.from_date_time
            }
            onChange={this.handleChange}
            name="from_date_time"
            className="mb-3"
          >
            <option value="">
              {TF("{0} {1}", T("Select"), T("Duration"))}{" "}
            </option>
            <option value="1">{TF("{0}", T("Starts in first half"))} </option>
            <option value="2">{TF("{0}", T("Starts in second half"))} </option>
          </AvField>
        </AvGroup>
      );

    const end =
      this.state.checked == "1" || this.state.hourchecked == "1" ? null : (
        <AvGroup>
          <Label for="example">
            {TF("{0} {1} {2}", T("Select"), T("End"), T("Time"))}
          </Label>
          <AvField
            type="select"
            id="end_date_time"
            value={formData ? formData.end_date_time : this.state.end_date_time}
            onChange={this.handleChange}
            name="end_date_time"
            className="mb-3"
          >
            <option value="">
              {TF("{0} {1}", T("Select"), T("Duration"))}{" "}
            </option>
            <option value="1">{TF("{0}", T("End in first half"))} </option>
            <option value="2">{TF("{0}", T("End in second half"))} </option>
          </AvField>
        </AvGroup>
      );
    return (
      <React.Fragment>
        <div className="text-center mt-4">
          {/* <h1 className="h2">Reset password</h1> */}
        </div>
        <Card>
          <CardBody>
            <div className="m-sm-4">
              <div
                style={
                  this.state.form == "1"
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <div className="text-center">
                  {/* <img src={image2} style={{'width':'40px','height':'40px'}}></img> */}
                  <img
                    src={image2}
                    style={{ width: "40px", height: "40px;" }}
                  ></img>
                  <img
                    src={image}
                    style={{ width: "250px", height: "38px;" }}
                  ></img>
                </div>
                <br />
                <br />
                <p className="lead">Enter your Employee ID</p>
                <Form className="form" id="pform" onSubmit={this.onFormSubmit}>
                  <FormGroup>
                    <Label>Employee ID</Label>
                    <Input
                      bsSize="lg"
                      type="text"
                      id="employee_id"
                      name="employee_id"
                      placeholder="Enter your Employee ID"
                    />
                    <br />
                    {/* <Label>Password</Label>
                  <Input
                    bsSize="lg"
                    type="password"
                    name="password"
                    placeholder="Enter your Password"
                  /> */}
                  </FormGroup>
                  {/* <Link to="auth/reset"></Link> */}
                  {/* <small>
                <Link to="/auth/reset">Forgot password?</Link>
              </small> */}
                  <div className="text-center mt-3">
                    {/* <Link to="/dashboard"> 
               <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
               Sign in
             </Button>  
              </Link> */}
                    {/* <a href="http://localhost:3000/dashboard" > 
              <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
               Sign in
             </Button>        
           </a> */}
                  </div>
                  {/* <a href="<?=site_url('user_verification? email=' . $email );?> ">Click To Verifiy Email </a> */}

                  <div className="text-center mt-3">
                    {/* <a href="<?=site_url('user_verification?email=' . $email );?> ">Click To Verifiy Email </a> */}

                    {/* <Link to="auth/reset"> */}
                    <Button
                      color="primary"
                      style={{ margin: "0rem 1.50rem 0rem 0rem" }}
                      size="lg"
                      onClick={this.onFormSubmit}
                    >
                      submit
                    </Button>
                    <Button
                      color="primary"
                      size="lg"
                      onClick={this.onFormCancel}
                    >
                      Cancel
                    </Button>
                    {/* <Link to={'/' + myConstClass.TENANT_PAGE_PATH + "attendance/listing"} style={{ margin: "0rem 1.50rem 1.50rem 0rem", border: "#6f42c1 1px solid", color: "#6f42c1", padding: "0.10rem 0.90rem 0.30rem 0.90rem", textDecoration: 'none', borderRadius: '0.2rem' }}>{T("Cancel")}</Link> */}

                    {/* <Button disabled={submitted}>{
                              (submitted && 'Your form is submitted!')
                              || (!submitted && 'Submit')
                          }</Button> */}
                    {/* </Link> */}
                  </div>

                  {/* <center><img src={image3} style={{'width':'40%'}}></img><br/>    */}
                  {/* <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
                </Form>
              </div>
            </div>

            <div
              //className="text-center"
              style={
                this.state.form == "0"
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <AvForm
                id="pformm"
                onSubmit={this.handleSubmit}
                onValidSubmit={this.handleValidSubmit}
              >
                <h4>
                  {T("Overtime")} {T("Request")}
                  <span
                    style={{ color: "red", fontSize: "14px", float: "right" }}
                  >
                    {" "}
                    {T("All fields marked with * are required")}{" "}
                  </span>
                </h4>
                <hr />
                <Row>
                  <Col lg={6}>
                    <Label for="example">
                      {T("Select")} {T("Employee")}{" "}
                    </Label>
                    <span style={{ color: "red", fontSize: "15px" }}> *</span>
                    <AvGroup>
                      <AvField
                        type="select"
                        id="employee_id"
                        name="employee_id"
                        value={this.state.employee_id}
                        readOnly={this.state.user_id != "0" ? true : false}
                        required
                      >
                        <option disabled="true">
                          {T("Select")} {T("Employee")}
                        </option>
                        {emp
                          ? emp.map((cell) => {
                              return (
                                <option value={cell.id}>
                                  {cell.status} {cell.first_name}{" "}
                                  {cell.last_name} ({cell.employee_id})
                                </option>
                              );
                            })
                          : ""}
                      </AvField>

                      <AvFeedback>
                        {" "}
                        {T("Enter")} {T("Employee")}
                      </AvFeedback>
                    </AvGroup>
                  </Col>

                  <Col lg={6}>
                    <Label id="spanfmdatelabel" for="example">
                      {T("Enter")} {T("Date")}
                    </Label>
                    <span style={{ color: "red", fontSize: "15px" }}> *</span>{" "}
                    <br />
                    <DatePicker
                      name="ot_date"
                      required
                      selected={this.state.ot_date}
                      className="form-control"
                      onChange={this.handleFromDateChange}
                      dateFormat="dd-MM-yyyy"
                      id="spanfmdatebox"
                    />
                    <span
                      id="spanfmdate"
                      style={{ color: "red" }}
                      //style={this.state.showGalleryPlayButton}
                      style={{ display: "none" }}
                      class="invalid-feedback11"
                    >
                      {T("Enter")} {T("Date")}
                    </span>
                  </Col>
                </Row>

                <br />
                <Row>
                  <Col lg={6}>
                    <AvGroup>
                      <Label for="example">
                        {TF(
                          "{0}-{1} - {2}:{3}",
                          T("From"),
                          T("Time"),
                          T("Hrs"),
                          T("Min")
                        )}

                        <span style={{ color: "red", fontSize: "15px" }}>
                          {" "}
                          *
                        </span>
                      </Label>
                      <AvInput
                        name="from_time"
                        id="example"
                        type="text"
                        required
                        value={formData ? formData.from_time : ""}
                      />
                      <AvFeedback>
                        {" "}
                        {TF("{0} {1} {2}!", T("Enter"), T("In"), T("Time"))}
                      </AvFeedback>
                    </AvGroup>
                  </Col>

                  <Col lg={6}>
                    <AvGroup>
                      <Label for="example">
                        {TF(
                          "{0}-{1} - {2}:{3}",
                          T("To"),
                          T("Time"),
                          T("Hrs"),
                          T("Min")
                        )}

                        <span style={{ color: "red", fontSize: "15px" }}>
                          {" "}
                          *
                        </span>
                      </Label>
                      <AvInput
                        name="to_time"
                        id="example"
                        type="text"
                        required
                        value={formData ? formData.to_time : ""}
                      />
                      <AvFeedback>
                        {" "}
                        {TF("{0} {1} {2}!", T("Enter"), T("To"), T("Time"))}
                      </AvFeedback>
                    </AvGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <AvGroup>
                      <AvField
                        type="select"
                        name="ot_type"
                        label={TF("{0} {1}", T("Ot"), T("Type"))}
                        value={
                          formData && formData.ot_type !== undefined
                            ? formData.ot_type
                            : "1"
                        }
                      >
                        <option value="0">30%</option>
                        <option value="1">100%</option>
                        <option value="2">150%</option>
                        <option value="3">200%</option>
                      </AvField>
                    </AvGroup>
                  </Col>

                  <Col lg={6}>
                    <AvGroup>
                      <Label for="example">
                        {TF("{0} {1}", T("Total"), T("Overtime"))}{" "}
                        <span style={{ color: "red", fontSize: "15px" }}>
                          {" "}
                          *
                        </span>
                      </Label>
                      <AvInput
                        name="total_ot"
                        id="example"
                        type="text"
                        required
                        value={formData ? formData.total_ot : ""}
                      />
                      <AvFeedback>
                        {" "}
                        {TF("{0} {1} {2}!", T("Enter"), T("Total"), T("OT"))}
                      </AvFeedback>
                    </AvGroup>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6}>
                    <AvGroup>
                      <Label for="example">
                        {TF("{0} {1}", T("Employee"), T("Remark"))}{" "}
                        <span style={{ color: "red", fontSize: "15px" }}>
                          {" "}
                          *
                        </span>
                      </Label>
                      <AvInput
                        type="textarea"
                        name="employee_remark"
                        id="example"
                        required
                        value={formData ? formData.employee_remark : ""}
                      />
                      <AvFeedback>
                        {TF(
                          "{0} {1} ...!",
                          T("Enter"),
                          T("Employee"),
                          T("Remark")
                        )}
                      </AvFeedback>
                    </AvGroup>
                  </Col>
                    <Col lg={6}>
                                    <AvGroup>
                                      <AvField
                                        //style={(this.state.reserved == '1') ? {pointerEvents:'none'}:{pointerEvents:'cursor'}}
                                        type="select"
                                        name="is_deleted"
                                        label={T("Active")}
                                        // readOnly={(this.state.reserved == '1') ? 'disabled' : false}
                                        value={formData ? formData.is_deleted : "0"}
                                        // onChange={this.ochangealcodeactive}
                                        // value={this.state.organization_id}
                                      >
                                        <option value={0}>{T("Yes")}</option>
                                        <option value={1}>{T("No")}</option>
                  
                                        {/* <option value={3}>Already Expired</option> */}
                                      </AvField>
                                    </AvGroup>
                                  </Col>
                  {/* <Col lg={6}>
                               <AvGroup>
                                 <AvField
                                      type="select"
                                   name="is_deleted"
                                   label={T("Active")}
                                       value={formData ? formData.is_deleted : "0"}
                                  
                                 >
                                   <option value={0}>{T("Yes")}</option>
                                   <option value={1}>{T("No")}</option>
             
                                
                                 </AvField>
                               </AvGroup>
                             </Col> */}
                </Row>

                {/* <Row>
                             <Col lg={6}>
                               <AvGroup>
                                 <Label for="example">
                                   {TF("{0} {1}", T("Supervisor"), T("Remark"))}
                                 </Label>
                                 <AvInput
                                   type="textarea"
                                   name="superviser_remark"
                                   id="example"
                                   value={formData ? formData.superviser_remark : ""}
                                 />
                               </AvGroup>
                             </Col>
             
                             <Col lg={6}>
                               <AvGroup>
                                 <AvField
                                   type="select"
                                   name="superviser_approval"
                                   label={TF("{0} {1}", T("Supervisor"), T("Approval"))}
                                   value={formData ? formData.superviser_approval : ""}
                                 >
                                   <option disabled={true}> {T("Select")}</option>
                                   <option value="2">{T("No")}</option>
                                   <option value="1">{T("Yes")}</option>
                                 </AvField>
                               </AvGroup>
                             </Col>
                           </Row> */}

                {/* <Row>
                             <Col lg={6}>
                               <AvGroup>
                                 <Label for="example">
                                   {TF("{0} {1}", T("Hr"), T("Remark"))}
                                 </Label>
                                 <AvInput
                                   type="textarea"
                                   name="hr_remark"
                                   id="example"
                                   value={formData ? formData.hr_remark : ""}
                                 />
                               </AvGroup>
                             </Col>
             
                             <Col lg={6}>
                               <AvGroup>
                                 <AvField
                                   type="select"
                                   name="hr_approval"
                                   label={TF("{0} {1}", T("HR"), T("Approval"))}
                                   value={formData ? formData.hr_approval : ""}
                                 >
                                   <option disabled={true}> {T("Select")}</option>
                                   <option value="2">{T("No")}</option>
                                   <option value="1">{T("Yes")}</option>
                                 </AvField>
                               </AvGroup>
                             </Col>
                           </Row> */}

                <FormGroup>
                  <Button disabled={submitted}>{T("Add")}</Button>
                </FormGroup>
              </AvForm>

              <Button color="primary" size="lg" onClick={this.onFormCancel}>
                Go to Login
              </Button>
            </div>
          </CardBody>
        </Card>
        {/* <center><img src={image3} style={{'width':'35%'}}></img><br/>   
       <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
      </React.Fragment>
    );
  }
}

export default LogInForm;
